import { render, staticRenderFns } from "./TemaDinamico.vue?vue&type=template&id=f46d6660&scoped=true"
import script from "./TemaDinamico.vue?vue&type=script&lang=js"
export * from "./TemaDinamico.vue?vue&type=script&lang=js"
import style0 from "./TemaDinamico.vue?vue&type=style&index=0&id=f46d6660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d6660",
  null
  
)

export default component.exports